import {EventBus, FILTER_EVENT} from '@/utils/event-bus'
import {appInstance} from '@/utils/app-accessor'
import type {Ref} from 'vue'
import {clone} from '~/utils/helpers'

export const worker = (
    ctx: any,
    sortFn: any,
    filterFn: any,
    {data: {action, offers: data, filters, sortKey}}: any,
    groupFn: any = arr => arr
) => {
    if (action === 'load') {
        ctx.offers = data
    }
    console.time('filterWorker')
    ctx.postMessage(groupFn(sortFn(filterFn(ctx.offers, filters), sortKey)))
    console.timeEnd('filterWorker')
}

export const workerName = (productName: string) => `${productName}Worker`

export function onmessage(productName: string, STOP_FILTER: Function, filterActive: Ref, SET_OFFERS: Function) {
    appInstance.$workers[workerName(productName)].onmessage = ({data}: any) => {
        STOP_FILTER()
        console.timeEnd('filter')
        if (filterActive.value) return
        SET_OFFERS(data)
        EventBus.$emit(FILTER_EVENT)
    }
}

export const postMessageLoad = (productName: string, productStore: any, offers: any) => {
    console.time('filter')
    appInstance.$workers[workerName(productName)].postMessage({
        action: 'load',
        offers,
        filters: clone(productStore.filters),
        sortKey: productStore.sortFnName,
    })
}

export const postMessageFilter = (productName: string, productStore: any) => {
    console.time('filter')
    appInstance.$workers[workerName(productName)].postMessage({
        action: 'filter',
        filters: clone(productStore.filters),
        sortKey: productStore.sortFnName,
    })
}
